import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'About', path: '/about' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' }
  ];

  // Check if we're on homepage to determine initial state
  const isHomePage = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        (isScrolled || !isHomePage) ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/895f171f-daff-471b-bab4-8b4e3f0ae174.png"
              alt="Professional Roofing"
              className="h-10 sm:h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  (isScrolled || !isHomePage)
                    ? location.pathname === link.path
                      ? 'text-[#2B5BA6]'
                      : 'text-gray-700 hover:text-[#2B5BA6]'
                    : location.pathname === link.path
                    ? 'text-white font-semibold'
                    : 'text-white hover:text-gray-200'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button - Desktop */}
          <div className="hidden lg:block">
            <Link
              to="/contact"
              className="bg-[#2B5BA6] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#234a8a] transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Free Quote
            </Link>
          </div>

          {/* Mobile Menu Button - 48x48 tap target */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-12 h-12 flex items-center justify-center cursor-pointer rounded-lg hover:bg-black/5 active:bg-black/10 transition-colors"
            aria-label="Toggle menu"
          >
            <i
              className={`${
                isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
              } text-2xl ${(isScrolled || !isHomePage) ? 'text-gray-900' : 'text-white'}`}
            ></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu - Improved with animations */}
      <div 
        className={`lg:hidden bg-white border-t border-gray-200 overflow-hidden transition-all duration-300 ease-in-out ${
          isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-4 sm:px-6 py-4 space-y-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block py-3 px-4 text-base font-medium rounded-lg cursor-pointer transition-colors min-h-[48px] flex items-center ${
                location.pathname === link.path
                  ? 'text-[#2B5BA6] bg-blue-50'
                  : 'text-gray-700 hover:bg-gray-50 active:bg-gray-100'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <Link
            to="/contact"
            className="block w-full bg-[#2B5BA6] text-white px-6 py-4 rounded-lg font-medium text-center hover:bg-[#234a8a] active:bg-[#1e3d73] transition-colors cursor-pointer mt-4 min-h-[48px] flex items-center justify-center"
          >
            Get Free Quote
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
